export default __webpack_public_path__ + "static/media/reparatie_elektra.fe0e0bb7.svg";